
import React from 'react';

import ReactDOM from 'react-dom';
 
 
 import { Timeline } from '@jd/find-react';
 
import {
  IconFont
} from '@jd/find-react';
import KeeVue from '../base/KeeVue.js'
 
export default class FsTimeline extends KeeVue {
	constructor(props) {
		super(props);

		this.state = {
			isShow: false,
			randId: this.getRandString(),
			
			nodes:[ ]

		}

	}
	
	

	componentWillMount() {
		var that = this;
		this.registComponent(); 
		
		if(this.props.component.cp.url)
		{
			this.showUrl(this.props.component.cp.url);
		}
	}

	showUrl=(url)=>{ 
		
		this.url = url;
		this.doRequest(url,(ret)=>{
			if(ret&&ret.rows)
			{
				this.showData(ret.rows)
			} 
		})
	}
 
	showData=(list)=>{
		
		this.state.nodes = [];
		if(list)
		{
			list.map((item,index)=>{
				this.state.nodes.push({
					title:window.moment(item.operate_time).format('YYYY-MM-DD HH:mm:ss'),
					icon:(item.icon?item.icon:'glyphicon glyphicon-ok-circle'),
					color:(item.color?item.color:'#436ddb'),
					userInfo:item.operate_user_name,
					subContent:item.action,
				})
				
			})
		}
		
		this.refresh();
		
		//, {
		// 		"operate_user_name": "linkage02",
		// 		"action": "签收",
		// 		"suggest": null,
		// 		"operate_time": 1624031014000
		// 	}
		// {
		// 	title:'2021-05-12 09:09:09',
		// 	icon:'glyphicon glyphicon-ok-circle',
		// 	color:'#f19830',
		// 	userInfo:'宿迁市12345专员',
		// 	subContent:'对工单进行了创建',
		// }, 
	}
	
	componentWillReceiveProps(nextProps){
		
		if(nextProps.component && nextProps.component.cp.url!=this.url)
		{
			this.showUrl(nextProps.component.cp.url)
		}
		
	}
	

	render() {
	 
	 
		return ( 
		<Timeline mode="left">
		{
			  this.state.nodes.map((item,index)=>{
				
			return	 <Timeline.Item key={index} color={item.color} dot={<i className={item.icon} style={{color:item.color,fontSize:'18px'}}></i>}>
				 <div  style={{ color:'#ccc'}}>{item.title}</div>
				 <div style={{'background':'#f2f8ff',borderRadius:'4px' }}>
					 <div style={{ fontSize:'14px',lineHeight:'24px'}}>{item.userInfo}</div>
					 <div style={{ color:'#aaa',fontSize:'12px',lineHeight:'24px'}}>{item.subContent}</div> 
				 </div>
				 
				
				 </Timeline.Item>
			})
		}
	 
		</Timeline>
		);
	}
}



 